import { SnackService } from './../../services/utility/snacks.service';
import { SubscriptionService } from './../../services/home/subscription.service';
import { BlogActions } from 'src/app/store/blog/blog.actions';
import { InstitucionService } from './../../services/institucion/institucion.service';
import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { ThemingService } from 'src/app/services/utility/theming.service';
import { GlobalActions } from './global.actions';
import { tap } from 'rxjs/operators';
export class GlobalStateModel {
  public slugInstitucion!: string | undefined;
  public nombreInstitucion!: string | undefined;
  public institucionLoaded!: boolean;
  public scroll!: number;
  public showFloatMenu!: boolean;
  public showLoading!: boolean[];
  public enlacesEncabezado!: Enlace[];
  public videoconsulta!: boolean;
  public openMap!: boolean;
  public banner!: string;
  public logoSrc!: string;
  public faviconSrc!: string;
  public footer!: Footer;
  public postsCarrousel!: Post[];
  public post!: Post;
  public postPrincipal!: Post;
  public tema!: Tema;
}
export class Tema {
  primary!: string;
  accent!: string;
}
export class Footer {
  public contacto!: string;
  public web!: string;
  public telefono!: string;
  public ubicacion!: string;
  public facebook!: string;
  public instagram!: string;
  public twitter!: string;
  public whatsapp!: string;
  public youtube!: string;
  public direccionGmap!: Direccion;
}
export class Post {
  public imagen!: string;
  public titulo!: string;
  public resumen!: string;
  public contenido!: string;
  public meta!: string;
  public slug!: string;
}
export class Direccion {
  public calle!: string;
  public ciudad!: string;
  public codigo_postal!: string;
  public completa!: string;
  public lat!: string;
  public log!: string;
  public numero!: string;
  public pais!: string;
  public piso!: string;
  public provincia!: string;
  public titulo!: string;
}
export class Enlace {
  public titulo!: string;
  public link!: string;
}
const defaults = {
  slugInstitucion: '',
  nombreInstitucion: 'Institución',
  institucionLoaded: false,
  scroll: 0,
  showFloatMenu: true,
  openMap: false,
  showLoading: [],
  videoconsulta: true,
  enlacesEncabezado: [],
  banner: '',
  logoSrc: '',
  faviconSrc: '',
  footer: {
    contacto: '',
    web: '',
    ubicacion: '',
    telefono: '',
    facebook: '',
    instagram: '',
    twitter: '',
    whatsapp: '',
    youtube: '',
    direccionGmap: {
      calle: '',
      ciudad: '',
      codigo_postal: '',
      completa: '',
      lat: "-32.945409",
      log: "60.649373",
      numero: '',
      pais: '',
      piso: '',
      provincia: '',
      titulo: '',
    }
  },
  postsCarrousel: [],
  post: {
    imagen: '',
    titulo: '',
    resumen: '',
    contenido: '',
    meta: '',
    slug: ''
  },
  postPrincipal: {
    imagen: '',
    titulo: '',
    resumen: '',
    contenido: '',
    meta: '',
    slug: ''
  },
  tema: {
    primary: '',
    accent: '',
  }
};

@State<GlobalStateModel>({
  name: 'global',
  defaults,
})
@Injectable()
export class GlobalState {
  @Selector()
  static isLoading(state: GlobalStateModel) {
    const isLoading = state.showLoading.find((elem) => elem);
    if (isLoading) {
      return true;
    } else {
      return false;
    }
  }
  @Selector()
  static getBanner({ banner }: GlobalStateModel) {
    return banner;
  }
  constructor(
    private themingService: ThemingService,
    private institucionService: InstitucionService,
    private subscriptionService: SubscriptionService,
    private snackService: SnackService,
  ) { }
  @Action(GlobalActions.GetInstitucion)
  getInstitucion(
    { setState, getState }: StateContext<GlobalStateModel>,
    { slug }: GlobalActions.GetInstitucion
  ) {
    const state = getState();
    setState({
      ...state,
      slugInstitucion: slug
    });
  }
  @Action(GlobalActions.UpdateScroll)
  updScroll(
    { setState }: StateContext<GlobalStateModel>,
    { scroll }: GlobalActions.UpdateScroll
  ) {
    setState(patch({ scroll }));
  }
  @Action(GlobalActions.HideFloatMenu)
  hide({ setState }: StateContext<GlobalStateModel>) {
    setState(patch({ showFloatMenu: false }));
  }
  @Action(GlobalActions.OpenMap)
  OpenMap({ setState }: StateContext<GlobalStateModel>) {
    setState(patch({ openMap: true }));
  }
  @Action(GlobalActions.CloseMap)
  CloseMap({ setState }: StateContext<GlobalStateModel>) {
    setState(patch({ openMap: false }));
  }
  @Action(GlobalActions.ShowFloatMenu)
  show({ setState }: StateContext<GlobalStateModel>) {
    setState(patch({ showFloatMenu: true }));
  }
  @Action(GlobalActions.ShowLoader)
  showLoader({ getState, setState }: StateContext<GlobalStateModel>) {
    const state = getState();
    setState(patch({ showLoading: [...state.showLoading, true] }));
  }
  @Action(GlobalActions.HideLoader)
  hideLoader({ getState, setState }: StateContext<GlobalStateModel>) {
    const state = getState();
    const newShowLoading = [...state.showLoading].splice(1);
    setState(patch({ showLoading: newShowLoading }));
  }
  @Action(GlobalActions.SetThemeColors)
  SetThemeColors({ getState, setState }: StateContext<GlobalStateModel>,
    { primary, primaryDark, accent }: GlobalActions.SetThemeColors) {
    const state = getState();
    const theme = { primary, accent }
    setState({
      ...state,
      tema: theme
    })
    this.themingService.savePrimaryColor(primary)
    this.themingService.savePrimaryDark(primaryDark)
    this.themingService.saveAccentColor(accent)
  }
  @Action(GlobalActions.SetLogo)
  SetLogo({ setState }: StateContext<GlobalStateModel>,
    { logoSrc }: GlobalActions.SetLogo) {
    setState(patch({ logoSrc: logoSrc }));
  }
  @Action(GlobalActions.SetFavicon)
  SetFavicon({ setState }: StateContext<GlobalStateModel>,
    { faviconSrc }: GlobalActions.SetFavicon) {
    setState(patch({ faviconSrc: faviconSrc }));
  }
  @Action(GlobalActions.SetDatos)
  SetDatos({ setState, getState }: StateContext<GlobalStateModel>,
    { titulo,
      videoconsulta,
      contacto,
      web,
      ubicacion,
      telefono,
      facebook,
      instagram,
      twitter,
      whatsapp,
      youtube,
      direccionGmap }: GlobalActions.SetDatos) {
    const footerData = {
      contacto,
      web,
      ubicacion,
      telefono,
      facebook,
      instagram,
      twitter,
      whatsapp,
      youtube,
      direccionGmap
    };
    const state = getState();
    setState(
      {
        ...state,
        nombreInstitucion: titulo,
        videoconsulta: videoconsulta,
        footer: footerData
      });
  }
  @Action(GlobalActions.SetEnlacesEncabezado)
  setEnlacesEncabezado(
    { setState }: StateContext<GlobalStateModel>,
    { enlaces }: GlobalActions.SetEnlacesEncabezado
  ) {
    setState(
      patch({
        enlacesEncabezado: enlaces,
      })
    )
  }
  @Action(GlobalActions.SetBanner)
  SetBanner({ setState }: StateContext<GlobalStateModel>,
    { banner }: GlobalActions.SetBanner) {
    setState(patch({ banner: banner }));
  }
  @Action(GlobalActions.SetPostsCarrousel)
  SetPostsCarrousel({ setState }: StateContext<GlobalStateModel>,
    { postsCarrousel }: GlobalActions.SetPostsCarrousel) {
    setState(
      patch({ postsCarrousel: postsCarrousel }));
  }
  @Action(GlobalActions.LoadLanding)
  LoadLanding({ setState, dispatch }: StateContext<GlobalStateModel>,
    { slug }: GlobalActions.LoadLanding) {
    return this.institucionService.getInstitucion(slug).pipe(
      tap(
        (result) => {
          dispatch(new GlobalActions.SetThemeColors(
            result.institucion.tema.color_primario,
            '',
            result.institucion.tema.color_secundario
          ));
          dispatch(new GlobalActions.SetDatos(
            result.institucion.nombre,
            result.institucion.disponibilidades_virtuales,
            result.institucion.email,
            result.institucion.web,
            result.institucion.direccion_principal.completa,
            result.institucion.telefono,
            result.institucion.facebook,
            result.institucion.instagram,
            result.institucion.twitter,
            result.institucion.whatsapp,
            result.institucion.youtube,
            result.institucion.direccion_principal,
          ));
          dispatch(new GlobalActions.SetBanner(
            result.institucion.banner + '/2000'
          ));
          dispatch(new GlobalActions.SetFavicon(
            result.institucion.favicon
          ));
          dispatch(new GlobalActions.SetLogo(
            result.institucion.logo
          ));
          dispatch(new GlobalActions.SetEnlacesEncabezado(
            result.institucion.enlaces_encabezado
          ))
          let post_array = result.institucion.posts_instituciones;
          let post_carrousel: Post[] = [];

          post_array.forEach((post: any) => {
            if (post.tipo === 'carrusel') {
              post_carrousel.push(post.post);
            }
            if (post.tipo === 'destacado') {
              dispatch(new BlogActions.GetPostPrincipal(post.post.slug));
            }
          });
          dispatch(new GlobalActions.SetPostsCarrousel(post_carrousel));
          setState(
            patch({ institucionLoaded: true }));
        },
        (err) => { }
      )
    );
  }
  @Action(GlobalActions.SendSubscription)
  sendSubscription({ setState }: StateContext<GlobalStateModel>,
    { email }: GlobalActions.SendSubscription) {
    return this.subscriptionService.subscribeUser(email)
      .pipe(
        tap(
          (response) => {
            if (response.success === true) {
              const msg = "Te suscribiste a nuestro Newsletter de forma exitosa!"
              const button = "Aceptar"
              this.snackService.openSnackAlert(
                3500,
                {
                  button,
                  descripcion: msg,
                  icon: "check",
                  color: "primary",
                },
                "end",
                "bottom"
              )
            }
          },
          (error) => {
            if (error.error.success === false && error.error.error.status === 409) {
              const msg = "Esta cuenta de correo ya está suscripta a nuestro Newsletter"
              const button = "Aceptar"
              this.snackService.openSnackAlert(
                3500,
                {
                  button,
                  descripcion: msg,
                  icon: "warning",
                  color: "primary",
                },
                "end",
                "bottom"
              )
            }
          }
        )
      )
  }
}
